<template>
    <div id="wrapper">
        <Top></Top>
        <section id="inner-headline">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h2 class="pageTitle">会社情報</h2>
                </div>
            </div>
        </div>
        </section>
        <div class="container">
            <div class="title"><h2>代表のご挨拶</h2></div>
            <div class="row">
                <div class="col-md-12">
                    <div class="box">
                        <div class="col-md-11" style="margin:10px 10px 10px 30px">
                            <p><h3></h3>
                            <font size=3>　　弊社は「お客様に最高の満足度を提供する」という経営理念の下、私たちが提供させていただいているシステムが、より皆様の身近な存在になるべく、システム内容の向上や最新技術の導入、また市場調査やマーケットの開拓などに、全社員の総力でもって取り組んでまいりました。私たちのシステムが、皆様一人ひとりの快適な未来へつながっていく、その強い想いを持ってこれからも日々あらゆる事業に邁進していく所存です。<br>
                            <br>　　皆様のご愛顧に感謝しますとともに、今後ともご支援を賜りますよう、お願い申し上げます。</font></p>
                        </div>
                        <div class="col-md-11" style="text-align: right">
                            <p><h3></h3>
                            <font size=3>
                            <b>代表取締役社長</b><br>
                            陳　旭涛(ちん　きょくとう)</font></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section class="section1">
            <div class="container clearfix">
                <div class="content col-lg-12 col-md-12 col-sm-12 col-xs-12 clearfix">
                    <div class="title"><h2>会社概要</h2>
                        <h6>最終更新 : 2024/10/01</h6>
                    </div>
                    <table class="table table-striped" data-effect="fade">
                        <tbody>
                            <tr>
                                <th>会社名称</th>
                                <td>
                                    株式会社アサテクス
                                </td>
                            </tr>
                            <tr>
                                <th>会社名称(英)</th>
                                <td>
                                    Asatex Co.,Ltd.
                                </td>
                            </tr>
                            <tr>
                                <th>所在地</th>
                                <td>
                                    〒230-0017　神奈川県横浜市鶴見区東寺尾中台6-28　旭誠ビル
                                </td>
                            </tr>
                            <tr>
                                <th>設立日</th>
                                <td>
                                    平成31年4月26日
                                </td>
                            </tr>
                            <tr>
                                <th>資本金</th>
                                <td>
                                    5000万 円
                                </td>
                            </tr>
                            <tr>
                                <th>代表取締役</th>
                                <td>
                                    陳　旭涛(ちん　きょくとう)
                                </td>
                            </tr>
                            <tr>
                                <th>事業内容</th>
                                <td>
                                    技術者常駐型技術支援サービス（SES）<br>
                                    ソフトウェア受託開発<br>
                                    IT人材教育
                                </td>
                            </tr>
                            <tr>
                                <th>従業員</th>
                                <td>
                                    30人（2024年9月）
                                </td>
                            </tr>
                            <tr>
                                <th>事業年度</th>
                                <td>
                                    4月1日から翌年3月31日まで
                                </td>
                            </tr>
                            <tr>
                                <th>決算月</th>
                                <td>
                                    4月
                                </td>
                            </tr>
                            <tr>
                                <th>取引銀行</th>
                                <td>
                                    みずほ銀行<br>
                                    三菱UFJ銀行
                                </td>
                            </tr>
                            <!--
                            <tr>
                                <th>主要取引先</th>
                                <td>
                                    株式会社コムチュア<br>
                                </td>
                            </tr>
                            -->
                            <tr>
                                <th>ホームページ</th>
                                <td>
                                    <a href="http://www.asatex.jp">http://www.asatex.jp</a>
                                </td>
                            </tr>
                            <tr>
                                <th>TEL</th>
                                <td>
                                    080-4534-2556
                                </td>
                            </tr>
                            <tr>
                                <th>FAX</th>
                                <td>
                                    080-4534-2556
                                </td>
                            </tr>
                            <tr>
                                <th>Mail</th>
                                <td>
                                    総務部 : soumu@asatex.jp<br>
                                    営業部 : sales@asatex.jp
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            <!-- end content -->
            </div>
            <br>
        <!-- end container -->
        </section>	
        <a href="#" class="scrollup"><i class="fa fa-angle-up active"></i></a>
        <Footer></Footer>
    </div>
</template>

<script>
import Top from "@/components/TopMenu.vue"
import Footer from "@/components/Footer.vue"
export default{
    name: 'Home',
    components: {
        Top,
        Footer
    }
}
</script>
<!-- <script src="../assets/js/jquery.js"></script>
<script src="../assets/js/jquery.easing.1.3.js"></script>
<script src="../assets/js/bootstrap.min.js"></script>
<script src="../assets/js/jquery.fancybox.pack.js"></script>
<script src="../assets/js/jquery.fancybox-media.js"></script>
<script src="../assets/js/portfolio/jquery.quicksand.js"></script>
<script src="../assets/js/portfolio/setting.js"></script>
<script src="../assets/js/jquery.flexslider.js"></script>
<script src="../assets/js/animate.js"></script>
<script src="../assets/js/custom.js"></script>
<script src="../assets/js/owl-carousel/owl.carousel.js"></script>
<script src="../assets/js/easypiechart/easypiechart.min.js"></script>
<script src="../assets/js/nivo-lightbox.js"></script>
<script src="../assets/js/main.js"></script> -->
<!-- <script>
    $(document).ready(function(){
        $(".headerpage").load("header.html");
        $(".footerpage").load("footer.html");
    });
</script> -->
<!--
<script>
    // You can also use "$(window).load(function() {"
    $(function () {
      // Slideshow 4
      $("#slider4").responsiveSlides({
        auto: true,
        pager:true,
        nav:true,
        speed: 500,
        namespace: "callbacks",
        before: function () {
          $('.events').append("<li>before event fired.</li>");
        },
        after: function () {
          $('.events').append("<li>after event fired.</li>");
        }
      });

    });
 </script> -->
<!--banner Slider starts Here-->

<style scoped>
</style>